interface ISidePanelInfoSmall{
    descriptor: string,
    value: string,
}

export default function SidePanelBreadCrumb({descriptor, value} : ISidePanelInfoSmall) {

    return (
        <div className="side-panel__info-box margin__top--s">
            <p className="small">{descriptor}</p>
            <div className="side-panel__blue-background side-panel__breadcrumb-wrapper">
                <p className="breadcrumb">{value}</p>
            </div>
        </div>
    )
}